import { useRef, useState } from 'react';

import Form from 'app/components/Form';

import {
  getSimpleJobs
} from 'app/services/jobs';

import {
  searchCustomers
} from 'app/services/customers';

import {
  formatOptions
} from 'app/utils/options';

const MomentsUploadForm = props => {
  const {
    onClose,
    action,
    onSubmit,
    jobId,
    isDefault,
    customerIds,
    customerId,
    storyIds,
    hideJobSelect,
    hideDefaultCheckbox,
    hideCustomerSelect
  } = props;

  const jobIdRef = useRef(jobId);
  const storyIdsRef = useRef(storyIds || []);

  const [state, setState] = useState({
    jobId: jobIdRef.current,
    job: null,
    isDefault: !!isDefault,
    customerIds: customerIds || (customerId && [customerId]) || []
  });

  const onJobChange = (value, selectedOption) => {
    jobIdRef.current = value;

    let job = selectedOption.data;

    // if default is checked, then storyId will be job's template story ID
    if (state.isDefault) {
      storyIdsRef.current = [job.template_story_id];
    }

    setState(state => ({
      ...state, 
      jobId: value,
      job
    }));
  }

  // default checkbox will be disabled unless job is selected
  const isDefaultDisabled = !state.jobId;

  // customer will be shown unless default moments checkbox is checked
  const showCustomer = !state.isDefault;
  const onDefaultChange = value => {
    // if default is checked, then storyId will be job's template story ID
    if (value) {
      storyIdsRef.current = [state.job.template_story_id];
    }

    setState(state => ({
      ...state,
      isDefault: value
    }));
  }

  // selecting a job will filter the customer options,
  // but if a customer is selected first then the job should autofill
  const onCustomerChange = (value, selectedOptions) => {
    if (!selectedOptions || !selectedOptions.length) {
      return;
    }

    // all selected options will have the same contextId / jobId
    let jobId = state.jobId;
    if (jobId !== selectedOptions[0].contextId) {
      jobId = selectedOptions[0].contextId;
      jobIdRef.current = jobId;
    }

    storyIdsRef.current = selectedOptions.map(opt => opt.data.story_id);

    setState(state => ({
      ...state,
      jobId,
      customerIds: selectedOptions.map(opt => opt.value)
    }));
  }

  const getJobOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let jobs = await getSimpleJobs();
    return formatOptions(jobs);
  }

  const getCustomerLabel = (c) => {
    return c.name || c.email || c.access_code || c.id.toString()
  }

  const getCustomerOptions = async (page, perPage, filterValue) => {
    let customers = await searchCustomers(page, perPage, filterValue, jobIdRef.current);
    return formatOptions(customers, { contextId: 'job_id', label: getCustomerLabel });
  }

  let fields = [
    { name: 'job_id', label: 'Job', type: 'autocomplete', value: state.jobId, valueType: 'integer', getOptions: getJobOptions, onChange: onJobChange, hidden: hideJobSelect },
    { name: 'default', label: 'Default Moments', type: 'checkbox', onChange: onDefaultChange, disabled: isDefaultDisabled, hidden: hideDefaultCheckbox },
    { name: 'story_ids', type: 'hidden', value: storyIdsRef.current || [], valueType: 'integer', multiple: true }
  ]

  if (showCustomer) {
    fields.push({ name: 'customer_ids', label: 'Customers', type: 'autocomplete', multiple: true, value: state.customerIds, valueType: 'integer', getOptions: getCustomerOptions, contextId: state.jobId, onChange: onCustomerChange, hidden: hideCustomerSelect });
  }

  fields.push({ name: 'files', label: 'Select Files', type: 'file', multiple: true, allowVideo: true });

  return (
    <Form {...{
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default MomentsUploadForm;
